"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approvalActOnResponseSchema = exports.approvalActOnRequestSchema = exports.APPROVAL_ACT_ON_COMMENT_MAX = exports.approvalActOnVerbSchema = exports.APPROVAL_ACT_ON_VERBS = void 0;
const zod_1 = require("zod");
const approval_rules_1 = require("./approval-rules");
const approval_inbox_1 = require("./approval-inbox");
exports.APPROVAL_ACT_ON_VERBS = ['approve', 'reject', 'request_changes'];
exports.approvalActOnVerbSchema = zod_1.z.enum(exports.APPROVAL_ACT_ON_VERBS);
exports.APPROVAL_ACT_ON_COMMENT_MAX = 4000;
exports.approvalActOnRequestSchema = zod_1.z
    .object({
    action: exports.approvalActOnVerbSchema,
    role: approval_rules_1.pgApproverRoleSchema,
    comment: zod_1.z.string().trim().max(exports.APPROVAL_ACT_ON_COMMENT_MAX).optional(),
})
    .strict()
    .superRefine((value, ctx) => {
    if (value.action === 'approve')
        return;
    const comment = value.comment ?? '';
    if (comment.length === 0) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['comment'],
            message: 'Comment is required for Reject and Request Changes',
        });
    }
});
exports.approvalActOnResponseSchema = zod_1.z.object({
    workflow_id: zod_1.z.string().uuid(),
    entity_type: approval_rules_1.approvalEntityTypeSchema,
    entity_id: zod_1.z.string(),
    approval_status: approval_inbox_1.approvalInboxStatusSchema,
    resolved: zod_1.z.boolean(),
    cycle: zod_1.z.number().int().min(1),
});
//# sourceMappingURL=approval-act-on.js.map